import context from "antd/es/app/context";
import { Transition } from "../../../core/flows/Transition";
import { UpcomingPastBookingContext } from "../Context/UpcomingPastBookingContext";
import { TicketDetailContext } from "../../TicketDetail/Context/TicketDetailContext";
import { QuickExchangeContext } from "../../QuickExchange/Context/QuickExchangeContext";
import { BookItAgainContext } from "../../BookItAgain/Context/BookItAgainContext";
import { ChangeDateContext } from "../../ChangeDate/Context/ChangeDateContext";
import { ManageSeatingContext } from "../../ManageSeating/Context/ManageSeatingContext";
import { BookReturnJourneyContext } from "../../BookReturnJourney/Context/BookReturnJourneyContext";
import { OnHoldBookingContext } from "../../OnHoldBooking/Context/OnHoldBookingContext";

export class UpcomingPastBookingTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<UpcomingPastBookingContext>("upcomingPastBookingContext", this.entryStep)!
        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }
        if (context.nextTo === "RetrieveBooking") {
            context.routeTo = [];
            context.nextTo = ""
        } else if (context.nextTo === "TicketDetailFlow") {
            context.routeTo = ["TicketDetailFlow"];
            context.nextTo = ""
        }
        else {
            const ticketDetailContext = new TicketDetailContext()
            this.setCtx<TicketDetailContext>("ticketDetailContext", ticketDetailContext, this.entryStep)

            const quickExchangeContext = new QuickExchangeContext()
            this.setCtx<QuickExchangeContext>("quickExchangeContext", quickExchangeContext, this.entryStep)

            const bookItAgainContext = new BookItAgainContext()
            this.setCtx<BookItAgainContext>("bookItAgainContext", bookItAgainContext, this.entryStep)

            const changeDateContext = new ChangeDateContext()
            this.setCtx<ChangeDateContext>("changeDateContext", changeDateContext, this.entryStep)

            const manageSeatingContext = new ManageSeatingContext()
            this.setCtx<ManageSeatingContext>("manageSeatingContext", manageSeatingContext, this.entryStep)

            const bookReturnJourneyContext = new BookReturnJourneyContext()
            this.setCtx<BookReturnJourneyContext>("bookReturnJourneyContext", bookReturnJourneyContext, this.entryStep)

            const onHoldBookingContext = new OnHoldBookingContext()
            this.setCtx<OnHoldBookingContext>("onHoldBookingContext", onHoldBookingContext, this.entryStep)

            context.routeTo = ["UpcomingPastBooking_Step", "QuickExchangeFlow", "BookItAgainFlow", "ManageSeatingFlow", "OnHoldBookingFlow", "BookReturnJourneyFlow"];
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}